import { Navigate, useTypedParams } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_PLAY_EVENTTYPE_FIXTURE } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './__generated__/routeParams';

const PlayEventTypePage = () => {
  const { generateSportContextPath, sport } = useSportContext();
  const { eventType } = useTypedParams<PageParams>();

  const { currentUser } = useCurrentUserContext();

  const fixture =
    currentUser?.forcedIntoOnboarding && sport === Sport.FOOTBALL
      ? 'onboarding'
      : 'ongoing';

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_EVENTTYPE_FIXTURE, {
        params: {
          fixture,
          eventType,
        },
      })}
      replace
    />
  );
};

export default PlayEventTypePage;
